export default __webpack_public_path__ + "static/media/house.bg.d5cb293c.svg";